import createReactComponent from '../createReactComponent';
export default createReactComponent('x', 'IconX', [
  ['path', { d: 'M18 6l-12 12', key: 'svg-0' }],
  ['path', { d: 'M6 6l12 12', key: 'svg-1' }],
]);
